// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__gw-OX","insightsList":"newBusinessInsightsMenu_insightsList__1RyNT","active":"newBusinessInsightsMenu_active__bzRZv"};